import { AuthRefreshResponseSchema } from './auth-refresh.schema';
/**
 * Auth Refresh Endpoint Contract
 *
 * Trades the browser's HttpOnly session cookie for a new access token, so an
 * hour-old token never drops the user onto the login page mid-work. Takes no
 * request body: the session rides the cookie and the expired access token
 * rides the Authorization header, exactly as any other call sends it.
 *
 * Public in the routing sense only — the expired token would fail AuthGuard.
 * The endpoint verifies that token's signature itself and re-runs the full
 * login denial chain, so a disabled identity or a revoked membership loses
 * access at the next refresh.
 */ export const authRefreshContract = {
    method: 'POST',
    path: '/api/v2/auth/refresh',
    description: 'Renews the access token from the session cookie, returns a fresh session',
    responseSchema: AuthRefreshResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'No session cookie, unreadable access token, expired session, or the identity provider refused the refresh',
            403: 'Identity disabled, membership revoked, or tenant expired'
        }
    }
};

//# sourceMappingURL=auth-refresh.contract.js.map